import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { DXCAuthService } from './dxc-auth.service';

export const appLayoutGuard: CanActivateFn = () => {
  const router = inject(Router);
  const dxcAuthService = inject(DXCAuthService);
  const authToken = dxcAuthService.getAuthToken();
  const isLoggedIn = dxcAuthService.isLoggedIn();

  if (authToken && isLoggedIn) {
    return true;
  }

  dxcAuthService.clearSessionAndNavigateToAuth(router);
  return false;
};
